module.exports = __webpack_public_path__ + "static/img/balz707-663-325-gld.3b49d9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/2025/balz707-663-325-gld.jpg
// module id = rexD
// module chunks = 0